import { MIN_ROW_HEAD_WIDTH } from '@/components/property-compare/constants';
import React from 'react';

export const RowHeader: React.FC<{ label: string | React.ReactNode }> = (
  props
) => {
  return (
    <td
      style={{ minWidth: MIN_ROW_HEAD_WIDTH }}
      className="text-center border border-gray-300"
    >
      {props.label}
    </td>
  );
};
